module.exports = __webpack_public_path__ + "static/img/greenI.2fa494f.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/greenI.png
// module id = N5ns
// module chunks = 1